export const claimsModalEditingModes = {
  new: 1,
  resubmit: 2,
  editPending: 3,
  continuingClaim: 4,
};

export const claimsModalCompletionCodes = {
  submitted: 1,
  cancelled: 2,
  savedPartial: 3,
};
